import { useNavigate } from 'react-router-dom'
import GardenReopenCard from './GardenReopenCard'
import { useLayoutEffect, useState } from 'react'
import { Pie } from 'react-chartjs-2'
import { Pieoptions } from '../../../../../Helper/Data'
import { useAuthState } from '../../../../../Helper/Context'

export default function GardenReopenCardManage(props) {

    const { Countdata, HeaderMonthID, HeaderFinancialYear, MonthValue, YearValue, YearLabel, MonthLabel, WardValue, WardLabel, ProjectTypeId, DashboardName } = props

    const userDetails = useAuthState();
    const { year, setYear, Month, setMonth, Ward, setWard, CurrentYear, CurrentMonth } = userDetails
    const { UserID, token, RoleID } = userDetails.user

    const navigate = useNavigate()

    const ReopenWorkProgressNavigate = (name, screenFlag) => {
        if (name === "Reopen Assign") {
            if (activeButton == 0) {
                navigate(`/gardenreopenpending?name=${name}&ApiFlag=Garden_ReopenAssign&Flag=Garden_ReopenAssign&Year=${year?.ID}&YLable=${year?.Label}&Month=${Month?.ID}&MLable=${Month?.Label}&WardName=${Ward?.ID}&WLable=${Ward?.Label}&ProjectTypeId=${ProjectTypeId}&DashboardName=${DashboardName}`)
            } else {
                navigate(`/gardenreopenpending?name=${name}&ApiFlag=Civil_ReopenAssign&Flag=Civil_ReopenAssign&Year=${year?.ID}&YLable=${year?.Label}&Month=${Month?.ID}&MLable=${Month?.Label}&WardName=${Ward?.ID}&WLable=${Ward?.Label}&ProjectTypeId=${ProjectTypeId}&DashboardName=${DashboardName}`)
            }
        } else if (name === "Reopen Pending") {
            if (activeButton == 0) {
                navigate(`/gardenreopenpending?name=${name}&ApiFlag=Garden_ReopenPending&Flag=Garden_ReopenPending&Year=${year?.ID}&YLable=${year?.Label}&Month=${Month?.ID}&MLable=${Month?.Label}&WardName=${Ward?.ID}&WLable=${Ward?.Label}&ProjectTypeId=${ProjectTypeId}&DashboardName=${DashboardName}`)
            } else {
                navigate(`/gardenreopenpending?name=${name}&ApiFlag=Civil_ReopenPending&Flag=Civil_ReopenPending&Year=${year?.ID}&YLable=${year?.Label}&Month=${Month?.ID}&MLable=${Month?.Label}&WardName=${Ward?.ID}&WLable=${Ward?.Label}&ProjectTypeId=${ProjectTypeId}&DashboardName=${DashboardName}`)
            }
        } else if (name === "Reopen Completed") {
            if (activeButton == 0) {
                navigate(`/gardenreopenpending?name=${name}&ApiFlag=Garden_ReopenCompleted&Flag=Garden_ReopenCompleted&Year=${year?.ID}&YLable=${year?.Label}&Month=${Month?.ID}&MLable=${Month?.Label}&WardName=${Ward?.ID}&WLable=${Ward?.Label}&ProjectTypeId=${ProjectTypeId}&DashboardName=${DashboardName}`)
            } else {
                navigate(`/gardenreopenpending?name=${name}&ApiFlag=Civil_ReopenCompleted&Flag=Civil_ReopenCompleted&Year=${year?.ID}&YLable=${year?.Label}&Month=${Month?.ID}&MLable=${Month?.Label}&WardName=${Ward?.ID}&WLable=${Ward?.Label}&ProjectTypeId=${ProjectTypeId}&DashboardName=${DashboardName}`)
            }
        }
    }

    const [activeButton, setActiveButton] = useState(sessionStorage.getItem('Axg') ? sessionStorage.getItem('Axg') : 0);

    useLayoutEffect(() => {
        setActiveButton(sessionStorage.getItem('Axg') ? sessionStorage.getItem('Axg') : 0)
    }, [])

    const handleButtonClick = (index) => {
        sessionStorage.setItem('Axg', index)
        setActiveButton(index);
    };

    const ReopenWorkProgressdata = {
        labels: ["Reopen Assign", "Reopen Pending", "Reopen Completed"],
        datasets: [
            {
                // label: '# of Votes',
                data: [
                    activeButton == 0 ? Countdata?.Garden_ReopenAssignWork_Assign_TotalCount : Countdata?.Civil_ReopenAssignWork_Assign_TotalCount,
                    activeButton == 0 ? Countdata?.Garden_ReopenAssignWork_Pending_TotalCount : Countdata?.Civil_ReopenAssignWork_Pending_TotalCount,
                    activeButton == 0 ? Countdata?.Garden_ReopenAssignWork_Completed_TotalCount : Countdata?.Civil_ReopenAssignWork_Completed_TotalCount
                ],
                backgroundColor: [
                    "#41b2b0",
                    "#f38242",
                    "#293d7c",

                    // "#293d7c",
                    // "#41b2b0",
                    // "#f38242",

                ],
                borderColor: [
                    // '#28c8c1',
                    // '#172b4d',
                    // '#993366',
                    // '#593e89',
                    // '#94408e',
                    // '#c74382',
                    // '#fa5d00',
                    // '#529ad2',
                    // '#ffc137',
                ],
                borderWidth: 1,
            },
        ],
    };

    return (
        <div className='row m-1 p-0  bg-white mx-0'  >
            <div className=' mb-0  d-flex justify-content-between'>
                <div>
                    <h5 className="pt-2 ">Reopen Work Progress</h5>
                </div>

                <div className="btn-group float-end" role="group" aria-label="Basic outlined example" style={{ border: '1px solid #154779', borderRadius: '5px', }}>
                    <button
                        onClick={() => handleButtonClick(0)}
                        className={activeButton == 0 ? "btn fw-bold px-4 activebutton text-white" : "text-black fw-bold btn px-4"}
                    >Garden</button>
                    <button
                        onClick={() => handleButtonClick(1)}
                        className={activeButton == 1 ? "btn px-4 fw-bold activebutton text-white" : "text-black fw-bold btn px-4"}
                        type="button">Civil</button>
                </div>

            </div>
            <div className='m-0 ' > <hr className="mt-2" style={{ color: "#a3964e" }}></hr></div>
            <div className="col-12 col-lg-7">
                <div className="row pb-2 pt-1  ">

                    <div className="col-12 col-md-6 col-lg-6 ">
                        <GardenReopenCard
                            title="Reopen Assign"
                            cardName='py-2 wwork_img cursor'
                            imgPath='./assets/img/assignment.png'
                            count={activeButton == 0 ? Countdata?.Garden_ReopenAssignWork_Assign_TotalCount : Countdata?.Civil_ReopenAssignWork_Assign_TotalCount}
                            // navLink='/gardenreopenpending'
                            ReopenWorkProgressNavigate={ReopenWorkProgressNavigate}
                        />
                    </div>
                    <div className="col-12 col-md-6 col-lg-6 ">
                        <GardenReopenCard
                            title="Reopen Pending"
                            cardName='py-2 wwork_img cursor'
                            imgPath='./assets/img/ReopenPending2.png'
                            count={activeButton == 0 ? Countdata?.Garden_ReopenAssignWork_Pending_TotalCount : Countdata?.Civil_ReopenAssignWork_Pending_TotalCount}
                            // navLink='/gardenreopenpending'
                            ReopenWorkProgressNavigate={ReopenWorkProgressNavigate}
                        />
                    </div>

                    <div className="col-12 col-md-6 col-lg-6 ">
                        <GardenReopenCard
                            title="Reopen Completed"
                            cardName='py-2 wwork_img cursor'
                            imgPath='./assets/img/ReopenCompleted.png'
                            count={activeButton == 0 ? Countdata?.Garden_ReopenAssignWork_Completed_TotalCount : Countdata?.Civil_ReopenAssignWork_Completed_TotalCount}
                            navLink='/gardereopencomplete'
                            ReopenWorkProgressNavigate={ReopenWorkProgressNavigate}
                        />
                    </div>
                </div>
            </div>
            <div className="col-12 col-lg-5 pb-lg-2">
                <div className=" rounded-4 shadow-sm p-3 pt-2 mt-0 h-100 Chartborder ">

                    <div className="d-flex justify-content-center align-items-center h-100 ">
                        {
                            (activeButton == 0 ? Countdata?.Garden_ReopenAssignWork_Assign_TotalCount : Countdata?.Civil_ReopenAssignWork_Assign_TotalCount != 0)
                                || (activeButton == 0 ? Countdata?.Garden_ReopenAssignWork_Pending_TotalCount : Countdata?.Civil_ReopenAssignWork_Pending_TotalCount != 0) ||
                                (activeButton == 0 ? Countdata?.Garden_ReopenAssignWork_Completed_TotalCount : Countdata?.Civil_ReopenAssignWork_Completed_TotalCount != 0) ?
                                <Pie
                                    height={100}
                                    // width={100}
                                    options={Pieoptions}
                                    data={ReopenWorkProgressdata}
                                />
                                :
                                <div className='text-danger  my-auto align-item-center  justify-content-center fw-bolder' style={{ height: '7vh', }}>
                                    <img
                                        className='wwork_img me-3'
                                        src="../assets/img/bar-graph.png"
                                    />
                                    <span className=''>No Data Found</span>
                                </div>
                        }
                    </div>
                </div>
            </div>
        </div>
    )

}
